import { IconProps } from "../../utils/global-types/global-types";

const RoomTypeIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M14.5 8.21a2.5 2.5 0 0 0-1-.21h-9A2.503 2.503 0 0 0 2 10.5V14a.5.5 0 0 0 1 0v-.25a.253.253 0 0 1 .25-.25h11.5a.253.253 0 0 1 .25.25V14a.5.5 0 0 0 1 0v-3.5a2.5 2.5 0 0 0-1.5-2.29M12.75 3.5h-7.5A1.75 1.75 0 0 0 3.5 5.25V7.5a.125.125 0 0 0 .16.12c.273-.08.556-.12.84-.12h.132a.125.125 0 0 0 .125-.11 1 1 0 0 1 .993-.89H7.5a1 1 0 0 1 .994.89.125.125 0 0 0 .125.11h.764a.125.125 0 0 0 .125-.11 1 1 0 0 1 .992-.89h1.75a1 1 0 0 1 .994.89.125.125 0 0 0 .125.11h.131c.284 0 .567.04.84.12a.125.125 0 0 0 .16-.12V5.25a1.75 1.75 0 0 0-1.75-1.75"
      ></path>
    </svg>
  );
};

export default RoomTypeIcon;
